import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';

export interface IB2BForgetPinUseCase {
    execute(apikey: string, username: string, identityToken: string, authToken: string, apiToken: { [key: string]: string }): Promise<any>;
}

export class B2BForgetPinUseCase implements IB2BForgetPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, username: string, identityToken: string, authToken: string, apiToken: { [key: string]: string }): Promise<any> {
        const response = await this.authRepo.b2bForgotPin(apiKey, username, identityToken, authToken, apiToken);
        return response.data;
    }
}
